(() => {
  let activeSection = document.querySelector("[data-store-product]")?.closest(".shopify-section") || document;
  const states = new WeakMap();
  let data = { product: null, images: [] };
  const dialog = document.querySelector("[data-theme-dialog]");
  const content = document.querySelector("[data-theme-modal-content]");
  let product = null;
  let variant;
  let quantity = 1;
  let imageIndex = 0;
  let tourTimer;
  const base = window.Shopify?.routes?.root || "/";
  const money = amount => new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: window.Shopify?.currency?.active || "USD" }).format(amount / 100);
  const query = selector => activeSection.querySelector(selector);

  function activate(section) {
    if (!section?.querySelector("[data-store-product]")) return;
    if (states.has(activeSection)) Object.assign(states.get(activeSection), { variant, quantity, imageIndex });
    activeSection = section;
    if (!states.has(section)) {
      try {
        const parsed = JSON.parse(query("[data-store-product]").textContent);
        states.set(section, { data: parsed, variant: parsed.product?.variants?.find(item => item.available) || parsed.product?.variants?.[0], quantity: 1, imageIndex: 0 });
      } catch { return; }
    }
    const state = states.get(section);
    data = state.data;
    product = data.product;
    variant = state.variant;
    quantity = state.quantity;
    imageIndex = state.imageIndex;
  }

  function element(tag, text, classes) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (classes) node.className = classes;
    return node;
  }
  function open(title) {
    clearInterval(tourTimer);
    content.replaceChildren();
    const heading = element("h2", title, "pr-5 font-display text-4xl");
    heading.id = "theme-modal-title";
    content.append(heading);
    if (!dialog.open) dialog.showModal();
    document.body.classList.add("overflow-hidden");
  }
  function close() { clearInterval(tourTimer); dialog.close(); document.body.classList.remove("overflow-hidden"); }
  dialog.addEventListener("cancel", close);
  dialog.addEventListener("click", event => { if (event.target === dialog) close(); });

  function setImage(index) {
    if (!data.images[index] || !query("[data-product-image]")) return;
    imageIndex = index;
    query("[data-product-image]").src = data.images[index];
    activeSection.querySelectorAll("[data-thumbnail]").forEach((button, current) => {
      button.classList.toggle("border-primary", current === index);
      button.classList.toggle("border-transparent", current !== index);
      button.setAttribute("aria-pressed", String(current === index));
    });
  }
  function updateQuantity(value) {
    quantity = Math.max(1, Math.min(20, value));
    if (!query("[data-quantity]")) return;
    query("[data-quantity]").textContent = quantity;
    query('[data-action="quantity-minus"]').disabled = quantity <= 1;
    query('[data-action="quantity-plus"]').disabled = quantity >= 20;
  }
  function updateVariant() {
    const button = query('[data-action="add-to-cart"]');
    if (!button) return;
    button.disabled = !variant?.available;
    button.classList.toggle("opacity-50", !variant?.available);
    query("[data-add-label]").textContent = !product ? "Select a product in the theme editor" : !variant?.available ? "Sold out" : "Add to bag";
    if (variant) {
      query("[data-product-price]").textContent = money(variant.price);
      query("[data-compare-price]").textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : "";
      if (variant.featured_image?.src) query("[data-product-image]").src = variant.featured_image.src;
    }
  }
  function initializeProducts(root = document) {
    root.querySelectorAll("[data-store-product]").forEach(source => {
      const section = source.closest(".shopify-section") || source.parentElement;
      activate(section);
      if (product?.variants.length > 1 && !query("[data-variant-select]")) {
    const label = element("label", "Choose your option", "mb-4 block text-xs font-semibold");
    const select = element("select", undefined, "mt-2 block w-full border border-input bg-popover px-4 py-3 text-sm");
    select.setAttribute("data-variant-select", "");
    product.variants.forEach(item => { const option = element("option", item.title + (item.available ? "" : " — sold out")); option.value = item.id; option.selected = item.id === variant.id; select.append(option); });
    select.addEventListener("change", () => { activate(section); variant = product.variants.find(item => String(item.id) === select.value); updateVariant(); });
    label.append(select);
    query('[data-action="add-to-cart"]').parentElement.before(label);
      }
      updateVariant();
    });
  }
  initializeProducts();
  document.addEventListener("shopify:section:load", event => initializeProducts(event.target));
  document.addEventListener("shopify:section:unload", close);
  document.addEventListener("shopify:section:select", event => event.target.scrollIntoView({ behavior: "smooth", block: "start" }));

  async function fetchCart() {
    const response = await fetch(base + "cart.js");
    if (!response.ok) throw new Error("Could not load your bag. Please try again.");
    const cart = await response.json();
    document.querySelectorAll("[data-cart-count]").forEach(node => node.textContent = cart.item_count);
    return cart;
  }
  async function showCart() {
    open("YOUR LITTLE BAG OF MAGIC.");
    const loading = element("p", "Loading your bag…", "mt-6 text-sm");
    content.append(loading);
    try {
      const cart = await fetchCart();
      loading.remove();
      if (!cart.items.length) { content.append(element("p", "Your bag is waiting for a little magic.", "mt-8 text-sm")); return; }
      for (const item of cart.items) {
        const row = element("div", undefined, "flex gap-4 border-b border-border py-6");
        if (item.image) { const image = element("img", undefined, "h-24 w-20 object-cover"); image.src = item.image; image.alt = item.product_title; row.append(image); }
        const info = element("div", undefined, "flex-1");
        info.append(element("p", item.product_title, "text-sm font-semibold"), element("p", money(item.final_line_price), "mt-2 text-sm"));
        const controls = element("div", undefined, "mt-3 flex items-center gap-4");
        for (const [text, next, description] of [["−", item.quantity - 1, "Remove one item"], ["+", item.quantity + 1, "Add one item"]]) {
          const button = element("button", text, "px-2 py-1");
          button.setAttribute("aria-label", description);
          button.addEventListener("click", async () => {
            button.disabled = true;
            try { const result = await fetch(base + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: item.key, quantity: next }) }); if (!result.ok) throw new Error("Unable to update quantity. Check product availability."); await showCart(); }
            catch (error) { showError(error.message); button.disabled = false; }
          });
          if (text === "+") controls.append(element("span", String(item.quantity), "text-xs"));
          controls.append(button);
        }
        info.append(controls); row.append(info); content.append(row);
      }
      content.append(element("p", "Subtotal: " + money(cart.total_price), "mt-6 text-lg font-semibold"), element("p", "Shipping and taxes are calculated at checkout.", "mt-3 text-xs text-muted-foreground"));
      const checkout = element("a", "Continue to secure checkout →", "mt-6 block bg-primary px-5 py-4 text-center text-sm font-medium uppercase tracking-[0.18em] text-primary-foreground");
      checkout.href = base + "checkout";
      content.append(checkout);
    } catch (error) { loading.textContent = error.message; }
  }
  function showError(text) { const message = element("p", text, "mt-4 text-sm text-destructive"); message.setAttribute("role", "alert"); content.append(message); }

  document.addEventListener("click", async event => {
    if (!(event.target instanceof Element)) return;
    activate(event.target.closest(".shopify-section"));
    const thumbnail = event.target.closest("[data-thumbnail]");
    if (thumbnail) setImage(Number(thumbnail.dataset.thumbnail));
    const button = event.target.closest("[data-action]");
    if (!button) return;
    switch (button.dataset.action) {
      case "close-modal": close(); break;
      case "menu": { const menu = button.closest(".shopify-section")?.querySelector("[data-mobile-menu]") || document.querySelector("[data-mobile-menu]"); if (!menu) break; menu.hidden = !menu.hidden; button.setAttribute("aria-expanded", String(!menu.hidden)); break; }
      case "quantity-minus": updateQuantity(quantity - 1); break;
      case "quantity-plus": updateQuantity(quantity + 1); break;
      case "next-image": setImage((imageIndex + 1) % data.images.length); break;
      case "cart": await showCart(); break;
      case "add-to-cart":
        if (!variant?.available) break;
        button.disabled = true;
        query("[data-add-label]").textContent = "Adding your magic…";
        try {
          const response = await fetch(base + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: variant.id, quantity }] }) });
          if (!response.ok) { const error = await response.json(); throw new Error(error.description || "Unable to add this item."); }
          await showCart();
        } catch (error) { open("A LITTLE HICCUP."); showError(error.message); }
        finally { updateVariant(); }
        break;
      case "tour": {
        if (!product || !data.images.length) { open("THE DETAILS, UP CLOSE."); content.append(element("p", "Select a featured product in Theme settings → Product to show its photos.", "mt-5 text-sm")); break; }
        open("THE DETAILS, UP CLOSE.");
        const image = element("img", undefined, "mt-5 aspect-square w-full rounded-lg object-cover");
        let slide = 0;
        image.src = data.images[slide]; image.alt = product?.title || "Product photo tour";
        content.append(image, element("p", "Animated product photo tour. Product images shown; not a product demonstration video.", "mt-4 text-xs leading-6 text-muted-foreground"));
        tourTimer = setInterval(() => { slide = (slide + 1) % data.images.length; image.src = data.images[slide]; }, 3000);
        break;
      }
      case "review":
        if (document.querySelector("#reviews")?.parentElement.querySelector(".shopify-app-block")) { document.querySelector("#reviews").parentElement.querySelector(".shopify-app-block").scrollIntoView({ behavior: "smooth" }); }
        else { open("SHARE YOUR LITTLE MAGIC."); content.append(element("p", "No verified review provider is connected yet. Store owner: add your review app as an app block in the theme editor to collect and display real customer reviews.", "mt-6 text-sm leading-8 text-muted-foreground")); }
        break;
    }
  });
  document.addEventListener("click", event => { if (!(event.target instanceof Element)) return; const link = event.target.closest("[data-mobile-menu] a"); if (!link) return; link.closest("[data-mobile-menu]").hidden = true; link.closest(".shopify-section")?.querySelector('[data-action="menu"]')?.setAttribute("aria-expanded", "false"); });
  fetchCart().catch(() => {});
})();
